/**
 * Het belvenster zonder zaak (sessie 47, 9d): vanuit "Nieuw bericht" en de
 * klantpagina. Na het starten de groene balk; de telefoonzaak ontstaat pas
 * als Rinkel het gesprek meldt.
 */
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import type { BelGestart } from "@/lib/werkplek-api";

import { Belbalk } from "./Belbalk";
import { Belvenster } from "./Belvenster";
import { sluitLosBellen, useLosBellen } from "./losBellen";
import "./tegel.css";

export function LosBelpaneel() {
  const los = useLosBellen();
  const navigeer = useNavigate();
  const [gesprek, setGesprek] = useState<BelGestart | null>(null);
  if (!los && !gesprek) return null;
  return (
    <div className="wp-losbellen" data-testid="wp-losbellen">
      {gesprek ? (
        <>
          <Belbalk
            gesprek={gesprek}
            onKlantpagina={(klantId) => navigeer(`/klanten/${klantId}`)}
            onSluiten={() => {
              setGesprek(null);
              sluitLosBellen();
            }}
          />
          <p className="wp-losbellen-uitleg">
            Het gesprek komt op een zaak zodra Rinkel het meldt, met de regel
            {" \u201c"}JP belde {gesprek.klant_naam ?? gesprek.nummer} vanuit{" "}
            {los?.bron === "klantpagina" ? "klantpagina" : "Nieuw bericht"}
            {"\u201d"}.
          </p>
        </>
      ) : los ? (
        <Belvenster
          klantId={los.klantId}
          nummer={los.nummer}
          bron={los.bron}
          onGestart={(nieuw) => {
            setGesprek(nieuw);
          }}
          onSluiten={() => sluitLosBellen()}
        />
      ) : null}
    </div>
  );
}
